export default "__VITE_ASSET__e0a00584__"